import { all } from "redux-saga/effects";
import rootloginSaga from "./loginSaga";
import rootcustomerSaga from "./customerSaga";
import rootorderSaga from "./orderSaga";
import rootProductSaga from "./productSaga";
import rootsubscriptionSaga from "./subscriptionSaga";
import rootpriceTagSaga from "./priceTagsSaga";

export default function* rootSaga(): Generator {
  yield all([
    rootloginSaga(),
    rootcustomerSaga(),
    rootorderSaga(),
    rootProductSaga(),
    rootsubscriptionSaga(),
    rootpriceTagSaga(),
  ]);
}
